import { render } from "./ChangeInfoDialog.vue?vue&type=template&id=2681a622&scoped=true"
import script from "./ChangeInfoDialog.vue?vue&type=script&lang=js"
export * from "./ChangeInfoDialog.vue?vue&type=script&lang=js"

import "./ChangeInfoDialog.vue?vue&type=style&index=0&id=2681a622&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\Account\\web\\Medical-Account-Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2681a622"]])

export default __exports__